import { useContext, useEffect, useRef } from 'react'
import { WebsocketContext, WebsocketService } from '../contexts/websocket.context'
import { logger } from '../helpers/util'
import { useCustomEvent, usePubsub } from '@fold-dev/core'
import { useAuth } from './auth.hook'

export function useWebsocket() {
    const { error, disconnected, connected } = useContext(WebsocketContext)
    const { getToken } = useAuth()

    const leave = (room: string) => WebsocketService.getInstance().emit('leave', room)

    const join = (room: string) => {
        logger('WS JOIN (webs): ' + room)
        WebsocketService.getInstance().emit('join', { token: getToken(), room })
    }

    const createRoomName = (rooms: string[]) => {
        return rooms.join('+')
    }

    return {
        error,
        connected,
        disconnected,
        join,
        leave,
        createRoomName,
    }
}

export function useSubscription(eventName) {
    const { connected } = useContext(WebsocketContext)
    const { getToken } = useAuth()
    const cachedValues = useRef({})

    const leave = (room: string) => WebsocketService.getInstance().emit('leave', room)

    const join = (room: string) => {
        logger('WS JOIN (sub): ' + room)
        WebsocketService.getInstance().emit('join', { token: getToken(), room })
    }

    const handleCustomEvent = ({ detail }) => {}

    useCustomEvent(eventName, handleCustomEvent)

    useEffect(() => {
        //cachedValues.current = { eventName, connected }
        if (eventName && connected) join(eventName)
        return () => (eventName ? leave(eventName) : null)
    }, [eventName, connected])
}
